import { createFileRoute } from '@tanstack/react-router';
import { ScanView } from '../../scan/scan-view.js';

export interface ScanSearch {
  /** Start the camera straight away (from a "Scan a label" button elsewhere). */
  start?: boolean;
  /**
   * The last code read. Kept in the address, so the result survives anything that leaves the
   * view for a moment (a sign-in, a reload), UI3S-4.
   */
  code?: string;
  /** How it was read: the camera, or typed / a handheld scanner (the default). */
  via?: 'camera';
}

export const Route = createFileRoute('/_station/scan')({
  validateSearch: (search: Record<string, unknown>): ScanSearch => {
    const out: ScanSearch = {};
    if (search['start'] === true || search['start'] === 'true') out.start = true;
    const code = search['code'];
    if (typeof code === 'string' && code.trim() && code.length <= 512) out.code = code;
    else if (typeof code === 'number') out.code = String(code);
    if (search['via'] === 'camera') out.via = 'camera';
    return out;
  },
  component: ScanView,
});
